var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8887 9.04937L13.8444 9.04937V7.31396L4.8887 7.31396C4.39791 7.31396 4 7.70246 4 8.18165C4 8.66084 4.39791 9.04937 4.8887 9.04937Z",
    fill: "#252728"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8887 12.5316L13.8444 12.5316V10.7961L4.8887 10.7961C4.39791 10.7961 4 11.1846 4 11.6639C4 12.1431 4.39791 12.5316 4.8887 12.5316Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8887 14.2783V14.2784C4.39791 14.2784 4 14.6668 4 15.146C4 15.6253 4.39791 16.0137 4.8887 16.0137H11.1105C11.0402 15.8024 11.0031 15.5795 11.0031 15.3508C11.0031 14.968 11.1059 14.6007 11.298 14.2783L4.8887 14.2783Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6716 14.575C19.2328 14.1465 18.5211 14.1465 18.0822 14.575L17.1594 15.476V6.09728C17.1594 5.49124 16.6563 5 16.0356 5C15.4148 5 14.9117 5.49128 14.9117 6.09728L14.9117 15.476L13.9889 14.575C13.55 14.1465 12.8384 14.1465 12.3995 14.575C11.9606 15.0035 11.9606 15.6983 12.3995 16.1268L15.2407 18.9008C15.6787 19.3286 16.3912 19.3301 16.8304 18.9008L19.6716 16.1268C20.1105 15.6983 20.1105 15.0035 19.6716 14.575Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.9cccae248cb80e26d95f1675aabba20e.svg";
export { ForwardRef as ReactComponent };